<div class="w-100 px-4">
  <nav mat-tab-nav-bar>
    <a mat-tab-link *ngFor="let link of links" [routerLink]="link" (click)="activeLink = link" [active]="activeLink == link"> {{link}} </a>
  </nav>

  <router-outlet></router-outlet>
</div>
